import PageTemplate from "./PageTemplate";
import {getScreenSize} from "../helpers/screens";

export default {
  data() {
    return {
      aside: getScreenSize() !== "sm",
      navHeight: 0
    }
  },

  mounted() {
    this.navHeight = this.$refs.nav.clientHeight;
  },

  methods: {
    toggleAside() {
      if (getScreenSize() === "sm") {
        this.aside = !this.aside;
      }
    }
  },

  watch: {
    aside(newVal, val) {
      if (newVal) {

        anime({
          targets: this.$refs.aside,
          translateX: ['100vw', 0],
          opacity: [0.5, 1],
          easing: 'easeOutQuad',
          duration: 250,
          begin: () => {
            this.$refs.aside.classList.remove("hidden");
            anime({
              targets: this.$refs.nav,
              height: this.$refs.aside.clientHeight,
              easing: 'easeOutQuad',
              duration: 250,
            })
          }
        });

      } else {

        anime({
          targets: this.$refs.aside,
          translateX: [0, '100vw'],
          opacity: [1, 0.5],
          easing: 'easeOutQuad',
          duration: 250,
          complete: () => {
            this.$refs.aside.classList.add("hidden");
          }
        });

        anime({
          targets: this.$refs.nav,
          height: this.navHeight,
          easing: 'easeOutQuad',
          duration: 250,
        });

      }
    }
  },

  render(h) {
    return (
      <PageTemplate>
        <div class="container mx-auto px-6">
          <div class="flex -mx-6 lg:mx-0">
            <div class="w-full lg:w-2/12 lg:border-r" ref="nav">
              <div class="py-3 lg:py-12 border-b">
                <p class="font-bold text-base mb-5 border-b lg:border-0 pb-3 lg:pb-0 px-3 lg:px-0">
                  {this.$t('profile_edit_page.profile_settings')}
                </p>
                <ul class="text-base lg:mb-4 px-3 lg:px-0">
                  <li onClick={this.toggleAside}>
                    <router-link to={{name: 'ProfileEditPage'}} class="block p-2 px-0 lg:px-3" exactActiveClass="lg:bg-gray-200 lg:rounded-l">
                      {this.$t('profile_edit_page.profile')}
                      <i class="float-right mdi mdi-chevron-right lg:hidden"></i>
                    </router-link>
                  </li>
                  <li onClick={this.toggleAside}>
                    <router-link to={{name: 'PasswordEditPage'}} class="block p-2 px-0 lg:px-3" exactActiveClass="lg:bg-gray-200 lg:rounded-l">
                      {this.$t('profile_edit_page.reset_password')}
                      <i class="float-right mdi mdi-chevron-right lg:hidden"></i>
                    </router-link>
                  </li>
                </ul>
              </div>
              <div class="py-8 px-3 lg:px-0">
                <router-link to={{name: 'ProfilePage'}}
                   class="border-2 border-blue-500 rounded-full p-3 py-2 lg:py-3 text-sm focus:border-blue-400">
                  <i class="mdi mdi-arrow-left mr-2"></i>
                  {this.$t('profile_edit_page.return_to_profile')}
                </router-link>
              </div>
            </div>
            <div class="w-screen lg:w-10/12 hidden lg:block absolute left-0 lg:relative bg-white shadow-xl lg:shadow-none" ref="aside">
              <div class="flex items-center px-3 border-b lg:hidden">
                <div class="py-2 pr-5" onClick={this.toggleAside}>
                  <i class="mdi mdi-chevron-left text-2xl text-gray-800"></i>
                </div>
                <p class="font-bold text-base">
                  {this.$t('profile_edit_page.profile_settings')}
                </p>
              </div>
              <router-view/>
            </div>
          </div>
        </div>
      </PageTemplate>
    )
  }
}